function setupBoostSearchWidgetWidthFix() {
  let targetFormWrapper = null;
  let boostFormsObserver = null;
  let boostWidgetObserver = null;

  function matchWidgetToFormWrapper() {
    const boostWidget =
      document.querySelector('#boost-sd__search-widget-init-wrapper') ||
      document.querySelector('[id*="boost-sd__search-widget"]') ||
      document.querySelector('[class*="boost-sd__search-widget"]') ||
      document.querySelector('.boost-sd__search-widget');

    if (!boostWidget || !targetFormWrapper) {
      return;
    }

    const formRect = targetFormWrapper.getBoundingClientRect();

    boostWidget.style.width = `${formRect.width}px`;
    boostWidget.style.left = `${formRect.left}px`;
    boostWidget.style.maxWidth = `${formRect.width}px`;
    boostWidget.style.minWidth = `${formRect.width}px`;
  }

  function attachEventListenersToBoostForm(form) {
    const searchInput =
      form.querySelector('input[type="search"]') ||
      form.querySelector('input[name="q"]') ||
      form.querySelector('.boost-sd__search-form-input') ||
      form.querySelector('.boost-sd__search-widget-init-input') ||
      form.querySelector('input[type="text"]') ||
      form.querySelector('input');

    if (searchInput) {
      searchInput.addEventListener('focus', () => {
        targetFormWrapper = form;

        setTimeout(() => {
          matchWidgetToFormWrapper();
        }, 200);
      });

      searchInput.addEventListener('input', () => {
        targetFormWrapper = form;

        setTimeout(() => {
          matchWidgetToFormWrapper();
        }, 100);
      });

      searchInput.addEventListener('click', () => {
        targetFormWrapper = form;

        setTimeout(() => {
          matchWidgetToFormWrapper();
        }, 200);
      });

      searchInput.addEventListener('keydown', () => {
        targetFormWrapper = form;

        setTimeout(() => {
          matchWidgetToFormWrapper();
        }, 300);
      });
    }

    form.addEventListener('click', () => {
      targetFormWrapper = form;

      setTimeout(() => {
        matchWidgetToFormWrapper();
      }, 100);
    });
  }

  function setupBoostFormObserver() {
    boostFormsObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            const boostForms = node.querySelectorAll
              ? node.querySelectorAll('.boost-sd__search-form')
              : node.classList && node.classList.contains('boost-sd__search-form')
                ? [node]
                : [];

            if (boostForms.length > 0) {
              boostForms.forEach(form => {
                attachEventListenersToBoostForm(form);
              });
            }
          }
        });
      });
    });

    boostFormsObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function setupBoostWidgetObserver() {
    boostWidgetObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.id === 'boost-sd__search-widget-init-wrapper') {
              setTimeout(() => {
                matchWidgetToFormWrapper();
              }, 100);
            }

            const boostWidgets = node.querySelectorAll
              ? node.querySelectorAll('#boost-sd__search-widget-init-wrapper, [id*="boost-sd__search-widget"]')
              : [];

            if (boostWidgets.length > 0) {
              setTimeout(() => {
                matchWidgetToFormWrapper();
              }, 100);
            }
          }
        });
      });
    });

    boostWidgetObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function setupFormWrapperClickListeners() {
    const formWrappers = document.querySelectorAll('.form-wrapper predictive-search');

    formWrappers.forEach(wrapper => {
      const searchInput = wrapper.querySelector('input[type="text"], input[name="q"]');

      if (searchInput) {
        searchInput.addEventListener('focus', () => {
          targetFormWrapper = wrapper;

          setTimeout(() => {
            matchWidgetToFormWrapper();
          }, 100);
        });

        searchInput.addEventListener('input', () => {
          if (targetFormWrapper === wrapper) {
            setTimeout(() => {
              matchWidgetToFormWrapper();
            }, 50);
          }
        });
      }
    });

    // Handle search page header search forms
    const headerSearchForms = document.querySelectorAll('.header-search predictive-search');

    headerSearchForms.forEach(wrapper => {
      const searchInput = wrapper.querySelector('input[type="text"], input[name="q"], input[type="search"]');

      if (searchInput) {
        searchInput.addEventListener('focus', () => {
          targetFormWrapper = wrapper;

          setTimeout(() => {
            matchWidgetToFormWrapper();
          }, 200);
        });

        searchInput.addEventListener('input', () => {
          if (targetFormWrapper === wrapper) {
            setTimeout(() => {
              matchWidgetToFormWrapper();
            }, 100);
          }
        });

        searchInput.addEventListener('click', () => {
          targetFormWrapper = wrapper;

          setTimeout(() => {
            matchWidgetToFormWrapper();
          }, 200);
        });

        searchInput.addEventListener('keydown', () => {
          targetFormWrapper = wrapper;

          setTimeout(() => {
            matchWidgetToFormWrapper();
          }, 300);
        });
      }
    });

    const existingBoostForms = document.querySelectorAll('.boost-sd__search-form');

    existingBoostForms.forEach(form => {
      attachEventListenersToBoostForm(form);
    });
  }

  function setupResizeHandler() {
    let resizeTimeout;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);

      resizeTimeout = setTimeout(() => {
        if (targetFormWrapper) {
          matchWidgetToFormWrapper();
        }
      }, 150);
    });
  }

  function init() {
    setupFormWrapperClickListeners();
    setupBoostFormObserver();
    setupBoostWidgetObserver();
    setupResizeHandler();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}

setupBoostSearchWidgetWidthFix();
